import { Icon, type IconDefinition } from '@vrplatform/icons';
import { Text, rem, useMantineTheme } from '@mantine/core';
import type { MouseEventHandler } from 'react';

type Props = {
  icon?: IconDefinition;
  label: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export const TableInlineAction = ({
  icon = 'PlusIcon',
  label,
  onClick,
}: Props) => {
  const theme = useMantineTheme();

  return (
    <button
      onClick={onClick}
      style={{
        alignItems: 'center',
        background: 'transparent',
        border: 0,
        borderRadius: rem(6),
        color: theme.colors.neutral[5],
        cursor: 'pointer',
        display: 'inline-flex',
        gap: rem(4),
        height: rem(24),
        paddingInline: rem(6),
      }}
      type="button"
    >
      <Icon color={theme.colors.neutral[5]} icon={icon} size={12} />
      <Text
        c={theme.colors.neutral[5]}
        fw={500}
        fz={12}
        lh={1.4}
        style={{ letterSpacing: '0.01px', whiteSpace: 'nowrap' }}
      >
        {label}
      </Text>
    </button>
  );
};
